export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13248.80814e81.jpg";